import AppPaths from '@globals/paths'
import { colors } from '@globals/themes/defaultTheme'
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined'
import Badge from '@mui/material/Badge'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import { SxProps } from '@mui/material/styles'
import useInAppNotifications from '@shared/inAppNotifications/useInAppNotifications'
import { T } from '@transifex/react'
import { useLocation, useNavigate } from 'react-router'

const actionButtonStyle: SxProps = {
  pt: 0,
}

const selectedButtonStyle: SxProps = {
  '& .MuiBottomNavigationAction-label': {
    color: colors.bluePrimary,
  },
  '& svg': {
    color: colors.bluePrimary,
  },
  pt: 0,
}

const badgeStyle: SxProps = {
  '& .MuiBadge-badge': {
    backgroundColor: colors.coralPrimary,
    transform: 'translate(-2px, 4px)',
  },
}

type ActivityButtonProps = {
  hasNotificationBrowsePermission: boolean
}

const ActivityButton: React.FC<ActivityButtonProps> = ({ hasNotificationBrowsePermission }) => {
  const { hasUnreadNotifications } = useInAppNotifications(false, hasNotificationBrowsePermission)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const notificationActivityPath = AppPaths.tenant.notificationActivity()
  const isSelected = pathname === notificationActivityPath

  return (
    <BottomNavigationAction
      label={<T _str="Activity" />}
      value={notificationActivityPath}
      sx={isSelected ? selectedButtonStyle : actionButtonStyle}
      onClick={() => navigate(notificationActivityPath)}
      icon={
        <Badge
          variant="dot"
          invisible={!hasUnreadNotifications}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={badgeStyle}>
          <NotificationsOutlinedIcon />
        </Badge>
      }
    />
  )
}

export default ActivityButton
